import toast from 'react-hot-toast';
import { ExtrasCreatedToast } from '../components/ExtrasCreatedToast';

export const showExtrasCreatedToast = (creatorId: number) => {
  toast((t) => (
    <ExtrasCreatedToast
      creatorId={creatorId}
      onClose={() => toast.dismiss(t.id)}
    />
  ));
};
